import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../FlowCollector.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NopCollectorClass;
function NopCollector() {
  if (NopCollectorClass === VOID) {
    class $ {
      b1h(value, $completion) {
        return Unit_instance;
      }
      s1d(value, $completion) {
        return this.b1h((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
      }
    }
    initMetadataForObject($, 'NopCollector', VOID, VOID, [FlowCollector()], [1]);
    NopCollectorClass = $;
  }
  return NopCollectorClass;
}
var NopCollector_instance;
function NopCollector_getInstance() {
  return NopCollector_instance;
}
//region block: init
NopCollector_instance = new (NopCollector())();
//endregion
//region block: exports
export {
  NopCollector_instance as NopCollector_instancer81kq14zk5tc,
  NopCollector as NopCollector2h4omm21qc7hq,
};
//endregion

//# sourceMappingURL=NopCollector.mjs.map
